import {
  inventoryItemIdFormat,
  locationIdFormat,
  processingSessionIdFormat,
} from "@redotech/redo-model/ids";
import * as z from "zod/v4";
import { ProcessingSessionItem } from "./processing-session";

export const addUndeclaredItemToProcessingSession = {
  name: "addUndeclaredItemToProcessingSession" as const,
  input: z.object({
    sessionId: processingSessionIdFormat.schema,
    locationId: locationIdFormat.schema,
  }),
  output: z.object({
    sessionItem: ProcessingSessionItem,
    inventoryItemId: inventoryItemIdFormat.schema,
  }),
};
